/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type BackofficeUserFormDataFragment = {
  __typename?: 'BackofficeUser'
  customerTenants: Array<string> | null
  email: string
  firstName: string
  groupsApprover: Array<string>
  lastName: string
  ridepoolingServiceTenants: Array<string> | null
  fleets: Array<string>
  allFleets: boolean
  operatorTenants: Array<string> | null
  systemUser: boolean
  username: string
  organizationId: string
  userType: Types.UserType
  timedGroups: Array<{
    __typename?: 'BackofficeUserTimeGroup'
    expires: string | null
    groupName: string
  }>
  adminPanelTimedGroups: Array<{
    __typename?: 'BackofficeUserTimeGroup'
    expires: string | null
    groupName: string
  }> | null
  timedServiceAreas: Array<{
    __typename?: 'BackofficeUserTimeArea'
    expires: string | null
    serviceArea: string
  }>
}

export const BackofficeUserFormDataFragmentDoc = gql`
    fragment BackofficeUserFormData on BackofficeUser {
  customerTenants
  email
  firstName
  groupsApprover
  lastName
  ridepoolingServiceTenants
  fleets
  allFleets
  operatorTenants
  systemUser
  timedGroups {
    expires
    groupName
  }
  adminPanelTimedGroups {
    expires
    groupName
  }
  timedServiceAreas {
    expires
    serviceArea
  }
  username
  organizationId
  userType
}
    `
